<div class="fx-fill fx-layout-col">
  <div class="sheet-header">
    <div class="fx-layout-row fx-justify-start fx-align-baseline">
      <div class="sheet-title fx-flex-85-percent">
        <span> {{ asset?.toString() }} </span>
      </div>
    </div>
  </div>
  <div class="sidebar-sheet fx-flex-grow" cdk-scrollable>
    <div class="sidebar-picture-container fx-layout-col fx-justify-center fx-align-center">
      <img id="sidebar-picture"
        [src]="imageSource || appConfig.PLACEHOLDER_CAROUSEL"
        alt="{{ imageSource ? ('LABEL.ASSET_PICTURE' | translate) : ('LABEL.NO_ASSET_PICTURE' | translate) }}"/>
    </div>
    <div class="page-sidebar">
      <div class="sidebar-asset-summary fx-layout-col fx-gap-10">
        <div class="fx-layout-col">
          <h6>{{ 'LABEL.NUMBER' | translate }}{{ asset.identifier }}</h6>
          <div class="asset-state"> {{ asset.assetState }} </div>
        </div>
      </div>
      <hr>
        <div class="form-container">
          <div class="partial-section-body fx-layout-row fx-wrap">
            @for (tab of tabs; track tab) {
              <div class="field-single-container fx-flex-50-percent">
                <div class="field-builder-container">
                  <div class="read-field-container">
                    <div class="field-row">
                      <div class="field-label sheet-link tab-link" (click)="navigateToAssetSheet(tab.key)">
                        <span> {{ tab.name | translate }} </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
